import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss']
})
export class PublicComponent {
  showHidePassword: any;
  menu:any={
    titre:"Menu",
    items:[
      {libelle:"Login",path:"/public/login"}
    ]
  }
  
  showPassword() {
    this.showHidePassword = document.getElementById('passwordInput');
    if (this.showHidePassword.type == 'text') {
      this.showHidePassword.type = 'password';
    } else {
      this.showHidePassword.type = 'text';
    }
  }
}
